module.exports = __webpack_public_path__ + "img/horizontal-logo-dark.e2162a92.svg";